import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/sports/SportsClient.tsx");
